import { InjectionToken } from '@angular/core';
import { AccountGroupService } from '@galaxy/account-group';

export const ldExpiredToken: InjectionToken<AccountGroupService> = new InjectionToken<AccountGroupService>(
  'LDExpiredToken',
);
export const ldExpiringToken: InjectionToken<AccountGroupService> = new InjectionToken<AccountGroupService>(
  'LDExpiringToken',
);
export const ldRenewsInToken: InjectionToken<AccountGroupService> = new InjectionToken<AccountGroupService>(
  'LDRenewsInToken',
);
export const lspExpiredToken: InjectionToken<AccountGroupService> = new InjectionToken<AccountGroupService>(
  'LSPExpiredToken',
);
export const lspExpiringToken: InjectionToken<AccountGroupService> = new InjectionToken<AccountGroupService>(
  'LSPExpiringToken',
);
